import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from './authSlice';
import { CircularProgress, Box } from '@mui/material';
const baseUrl = process.env.REACT_APP_API_URL;
export const RequireAuth = ({ children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, loading, user, hasCheckedSession } = useSelector((state) => state.authSlice);
    useEffect(() => {
        if (!hasCheckedSession) {
            dispatch(fetchUser());
        }
    }, [dispatch, hasCheckedSession]);
    if (!hasCheckedSession) {
        // TODO: Show a loading spinner or some kind of placeholder while checking session
        return (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', children: _jsx(CircularProgress, {}) }));
    }
    if (!isAuthenticated) {
        const returnUrl = encodeURIComponent(window.location.href);
        window.location.href = `${baseUrl}/auth/login?returnUrl=${returnUrl}`;
        return null;
    }
    return children;
};
